import { render, staticRenderFns } from "./Notice.html?vue&type=template&id=51c62f1e&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=ts&"
export * from "./Notice.vue?vue&type=script&lang=ts&"
import style0 from "./Notice.scss?vue&type=style&index=0&id=51c62f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c62f1e",
  null
  
)

export default component.exports